// Admin routes for P5-D (INVENTORY, POS, SHIPPING, MOBILE PWA). Owned by that worker; the router mounts
// whatever this returns under the app shell (before the store-area placeholder), so modules never
// edit router.tsx. Paths follow IA §2.1.
import {
  createRoute,
  type AnyRoute,
  type RouteComponent,
  lazyRouteComponent,
} from "@tanstack/react-router";

// Pages are code-split: each loads when its route opens, not with the shell.
const load1 = () => import("../inventory/InventoryPage");
const InventoryPage = lazyRouteComponent(load1, "InventoryPage");
const load2 = () => import("../inventory/LocationsPage");
const LocationsPage = lazyRouteComponent(load2, "LocationsPage");
const load3 = () => import("../pos/SalesPage");
const SalesPage = lazyRouteComponent(load3, "SalesPage");
const load4 = () => import("../pos/SellPage");
const SellPage = lazyRouteComponent(load4, "SellPage");
const load5 = () => import("../shipping/DeliveryPage");
const DeliveryPage = lazyRouteComponent(load5, "DeliveryPage");
const load6 = () => import("../shipping/InstallationPage");
const InstallationPage = lazyRouteComponent(load6, "InstallationPage");

export function operationsRoutes(appRoute: AnyRoute): AnyRoute[] {
  const at = (path: string, component: RouteComponent) =>
    createRoute({ getParentRoute: () => appRoute, path, component });
  return [
    at("/$org/$store/inventory", InventoryPage),
    at("/$org/$store/sell", SellPage),
    at("/$org/$store/sell/sales", SalesPage),
    at("/$org/$store/apps/couriers/delivery", DeliveryPage),
    at("/$org/$store/settings/locations", LocationsPage),
    at("/$org/$store/settings/delivery/installation", InstallationPage),
  ];
}
